/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDataDialogPromptResponseContent
 */
export interface UpdateDataDialogPromptResponseContent {
    /**
     * 
     * @type {string}
     * @memberof UpdateDataDialogPromptResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the UpdateDataDialogPromptResponseContent interface.
 */
export function instanceOfUpdateDataDialogPromptResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateDataDialogPromptResponseContentFromJSON(json: any): UpdateDataDialogPromptResponseContent {
    return UpdateDataDialogPromptResponseContentFromJSONTyped(json, false);
}

export function UpdateDataDialogPromptResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDataDialogPromptResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UpdateDataDialogPromptResponseContentToJSON(value?: UpdateDataDialogPromptResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

